import { render, staticRenderFns } from "./TablaPasajeros.vue?vue&type=template&id=24cdf727&scoped=true"
import script from "./TablaPasajeros.vue?vue&type=script&lang=js"
export * from "./TablaPasajeros.vue?vue&type=script&lang=js"
import style0 from "./TablaPasajeros.vue?vue&type=style&index=0&id=24cdf727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cdf727",
  null
  
)

export default component.exports